/**
 * Fallback sidebar menu for unknown customer_type or when no type-specific rule applies.
 * easyPayOperator (type === 5): home + others.
 * Else: home + admin + others.
 */
export function getMenuList(context) {
  const { easyPayOperator, homeMenu, adminMenu, others } = context;
  if (easyPayOperator) {
    return [homeMenu, others].filter(Boolean);
  }
  return [homeMenu, adminMenu, others].filter(Boolean);
}
